import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment-timezone';
import { SelectMobileDialogComponent } from './select-mobile-dialog/select-mobile-dialog.component';
import { AccountService } from 'src/app/core/services/account.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { DayboardDateService } from '../dayboard-date.service';
import { PrincipalService } from 'src/app/core/services/principal.service';
import { SessionStorageService } from 'ngx-webstorage';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { AppConstant, AppEvents, DateFormat, OrderStatusCodes } from 'src/app/core/constants/app.constant';
import { faExclamationCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { IResponse, pharmacyHolidayResponse } from 'src/app/shared/models/app';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { CommonService } from '../common.service';
import { ToastService } from 'src/app/shared/utils/toast.service';
import { AccountAdministrationService } from 'src/app/modules/account/account-administration.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { AlertService } from 'src/app/modules/alerts/alert.service';
import { ConfirmDialogComponent } from 'src/app/core/dialog/confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';
import { RejectedRequestComponent } from './rejected-request/rejected-request.component';
import { ApplicationAlertComponent } from './application-alert/application-alert.component';
import { HomeService } from 'src/app/modules/home/home.service';
import { ShowSpecialProductComponent } from 'src/app/modules/home/pages/dashboard/show-special-product/show-special-product.component';
import { StaticService } from 'src/app/core/services/static.service';
import { UserService } from 'src/app/core/services/user.service';
import { Environment } from 'src/app/core/environment/environment';
import { RejectNotificationComponent } from './reject-notification/reject-notification.component';
import { TokenService } from 'src/app/core/services/token.service';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'nuctrac-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  /*********************Properties*********************/
  faQuestionCircle = faQuestionCircle;
  faExclamationCircle = faExclamationCircle;

  hideHeader: boolean = false;
  showUserInfo: boolean = false;
  showToday: boolean = false;
  showClock: boolean = true;
  showMobile: boolean = false;
  _versionVerified: boolean = false;
  showHeaderClockFlag: boolean = true;
  isReleaseNoteAvailable: boolean = false;
  maintenanceMsgFlag: boolean = false;

  selectedAccount: any;
  selectedMobile: any;
  mobileList: any;
  accountList: any;
  user: any;
  userRoleDetails: any;
  loggedInUser: any;
  defaultShipTo: any;
  currentDate: any;
  dayBoardDate: any;
  clockInterval: any;
  changedDate: any;
  userAccountDetails: any;

  currentTime: string = '';

  rejectedCount: number = 0;
  reservationCount: number = 0;

  mobiles = [];
  headerDetails =
    {
      mobileValue: null,
    }
  suggestionBox = "";
  mobile: any = null;
  noRoleAssignStatus = AppConstant.Messages.AccountRoles;
  @Output() headerHidden = new EventEmitter<boolean>()

  readonly session = { expiring: false, warning: true, timeRemaining: null, refreshed: false };


  private subscription: any = {
    scheduledReservation: null,
    rejectedRequests: null,
    dateChanged: null,
    showHeaderClock: null,
    updateMobileCnfgs: null,
    session: { expiring: null, expired: null },
  }
  appMaintenanceObj: any = {};

  appMaintenanceReleaseNote: any
  versionList: any[] = []
  noteTemplate!: string;
  showNewRejectNotification:boolean = false;
  restrictInternalUser: any;
  getLocationHolidayDates!: pharmacyHolidayResponse[];
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(
    private storage: SessionStorageService,
    private accountService: AccountService,
    private accountAdminService: AccountAdministrationService,
    private commonService: CommonService,
    private authService: AuthService,
    public dialog: MatDialog,
    private dayBoardDateService: DayboardDateService,
    private cache: CacheResolverService,
    private toastService: ToastService,
    private principal: PrincipalService,
    private alertService: AlertService,
    private utilityService: UtilityService,
    private _router: Router,
    private userService: UserService,
    private homeService: HomeService,
    private staticService: StaticService,
    private token: TokenService,
    private appService: AppService
  ) {
    this.restrictInternalUser = this.userService.isInternalUser() && Environment.getInstance().appConfig.restrictInternalUser;//process.env.RestrictInternalUser;
   }

  /*********************Constructor*********************/

  /*********************Lifecyle Methods*********************/
  ngOnInit() {
    this.userRoleDetails = this.cache.get(CacheConstant.LocalStorage.NoRoleAssigned);
    this.subscription.scheduledReservation = this.alertService.scheduledReservations$.subscribe(
      (data) => {
        this.showReservationPopover(data)
      },
    );
    this.subscription.rejectedRequests = this.commonService.rejectedRequestChanged$.subscribe(
      (data) => {
        this.rejectedCount = data;
      }
    );

    this.subscription.updateMobileCnfgs = this.accountAdminService.$updateMobileCnfgs.subscribe(
      (data) => {
        this.mobileList = this.cache.get(CacheConstant.LocalStorage.MobileCnfgs);
        this.mobiles = this.cache.get(CacheConstant.LocalStorage.MobileCnfgs);

      }
    )
    this.subscription.dateChanged = this.dayBoardDateService.dateChanged$.subscribe(
      (date) => {
        this.changedDate = date;
        this.dayBoardDate = moment(this.changedDate).format(DateFormat.DMDY)
        this.currentDate = new Date(this.changedDate)
        this.showToday = this.checkDate();
      }
    );
    this.subscription.session.expiring =
      this.token.apigee.tokenExpiring$.subscribe((expiring: any) =>
        this.onApigeeTokenExpiring(expiring)
      );
    this.subscription.session.expired =
      this.token.apigee.tokenExpired$.subscribe((expired: any) =>
        this.onApigeeTokenExpired(expired)
      );

    this.init();
  }

  private onApigeeTokenExpiring(tokenExpiration: any) {
    this.session.refreshed = false;
    this.session.expiring = tokenExpiration.expiring;

    if (this.session.expiring) {
      if (this.session.warning) {
        this.session.warning = false;
        this.refreshSession();
      }
    } else {
      this.session.timeRemaining = null;
    }
  }

  private refreshSession() {
    this.token.getAccessToken().then((response: any) => {
      if (response) {
        this.token.renew().subscribe((res :any)=>{
          this.storage.store(CacheConstant.SessionStorageData.RefreshToken, res['refresh_token']);
          this.storage.store(CacheConstant.SessionStorageData.AccessToken, res['access_token']);
          this.storage.store(CacheConstant.SessionStorageData.IdToken, res['id_token']);
          this.token.validate(res['access_token'], res['id_token']).subscribe((tokenResponse: any) => {
            if (!tokenResponse.hasError) {
              this.appService.load().then(() => {
                setTimeout(() => {
                  this.session.expiring = false;
                  this.session.warning = true;
                  this.session.refreshed = true;
                }, 3000);
              });
            } else {
              this.logOut();
            }
          });
        },
        (error)=>{
          this.logOut();
        }
        )
      }
    });
  }

  private onApigeeTokenExpired(expired: boolean) {
    if (expired) {
      this.authService.logOut();
    }
  }

  showReservationPopover(data: any) {
    if (data && data.reservationCount) {
      this.reservationCount = data.reservationCount;
      if (this.alertService.isReservationsLoaded() && this.mobiles.length == 0 && this.reservationCount > 0) {
        this.openReservationsDialog();
      }
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.clockInterval)
  }
  /*********************Lifecyle Methods*********************/

  /*********************Private Methods*********************/
  private init() {
    this.showMobile = false;
    // this.setDateTime()
    this.setClock()
    this.getAccountDetails();
    this.showNewRejectNotification = this.homeService.getNewRejectNotificationPreference();
    this.getPharmacyHolidayDates();
    // App Version dialog
    // this.validateApplicationVersion();

    // this.showHeaderClockFlag = this.cache.get(CacheConstant.LocalStorage.CustomerAdminSettings).displaySystemTimezoneFlag;
  }

  private getAccountDetails() {
    this.loggedInUser = this.cache.get(CacheConstant.LocalStorage.UserDetails);
    this.loadUserDetails(this.loggedInUser);
    this.principal.identity(this.selectedAccount?.customerShipToNum).then(response => {
      this.userAccountDetails = this.cache.get(CacheConstant.LocalStorage.AccountDetails);

      this.getMobileConfigurations();
    });


  }

  private getMobileConfigurations() {
    this.alertService.resetReservations();

    this.userAccountDetails = this.cache.get(CacheConstant.LocalStorage.AccountDetails);

    this.selectedAccount.isMobile = this.userAccountDetails.mobileTruckFLag ? true : false;
    if (this.selectedAccount?.isMobile) {
      var req = {
        customerShipToNum: this.selectedAccount.customerShipToNum
      }
      this.accountAdminService
        .getMobileConfigurations(req)
        .subscribe((response: IResponse) => {
          if (!response.hasError) {
            if (response.data?.length > 0) {
              this.mobileList = response.data.filter((obj: any) => obj.activeFlag == "Y");
              this.cache.set(CacheConstant.LocalStorage.MobileCnfgs, this.mobileList);
              if (this.mobileList.length > 0) {
                this.mobileList.forEach((mobile: any) => {
                  if (mobile.default) {
                    this.selectedMobile = mobile
                  }
                });
                this.showMobile = true;
                this.mobiles = this.mobileList;
                this.showMaintenanceBanner();
                // this.openMobileDialog();
              }
              else {
                this.showMobile = false;
                this.isRejectDialogReq();
              }
            }
            else {
              this.showMobile = false
              this.isRejectDialogReq();
            }
          }
          else {
            this.showMobile = false
            const message = response.error.faultInfos[0];
            this.toastService.error(message?.faultMessage, 'ERROR!')
            this.isRejectDialogReq();
          }

        });
    }
    else {
      this.showMaintenanceBanner();
    }
    let params = {
      customerShipToNum: this.selectedAccount.customerShipToNum
    };
    this.alertService.getReservationCount(params);


  }

  showMaintenanceBanner() {
    this.appMaintenanceObj = {};
    if (this.cache.get(CacheConstant.LocalStorage.UserDetails)) {
      this.appMaintenanceObj = this.cache.get(CacheConstant.LocalStorage.UserDetails).appMaintenance;
    }
    if (this.appMaintenanceObj != undefined && (this.appMaintenanceObj.maintenanceMsg != '' || this.appMaintenanceObj.maintenanceMsg != null)) {
      this.maintenanceMsgFlag = true;
      if ('releaseNote' in this.appMaintenanceObj && this.appMaintenanceObj.releaseNote != null) {
        this.isReleaseNoteAvailable = true;
        this.appMaintenanceReleaseNote = this.appMaintenanceObj.releaseNote.split(",");
      } else {
        this.isReleaseNoteAvailable = false;
      }
    } else {
      this.maintenanceMsgFlag = false;
    }
    if (this.maintenanceMsgFlag) {
      this.dialog.open(ApplicationAlertComponent, {
        width: '500px',
        height: '300px',
        panelClass: 'application-alert',
        data: { appMaintenanceObj: this.appMaintenanceObj, isReleaseNoteAvailable: this.isReleaseNoteAvailable, appMaintenanceReleaseNote: this.appMaintenanceReleaseNote },
      }).afterClosed().subscribe(result => {
        this.selectMobile();
      });
    }
    else {
      this.selectMobile();
    }
  }

  selectMobile() {
    if (this.selectedAccount.isMobile) {
      this.openMobileDialog();
    }
  }

  private setDateTime() {
    this.currentDate = moment().format();
    this.currentTime = moment().format(DateFormat.HHMMA);
    this.cache.set('CurrentDate', this.currentDate);
    // this.currentTime = this.utilityService.setlocalTimeZone(this.currentDate, this.cache.get(CacheConstant.SessionStorageData.TimeZoneText), DateFormat.HHMMA);
    this.dayBoardDate = moment().format(DateFormat.DMDY)
    this.showToday = this.checkDate();
  }

  private collapseHeader() {
    this.hideHeader = !this.hideHeader
    this.headerHidden.emit(this.hideHeader)
  }

  private setClock() {
    this.clockInterval = setInterval(() => {
      this.currentTime = moment().format(DateFormat.HHMMA);
      this.cache.set(CacheConstant.LocalStorage.CurrentTime, this.currentTime);
      //this.utilityService.setlocalTimeZone(this.currentDate, this.cache.get(CacheConstant.SessionStorageData.TimeZoneText), DateFormat.HHMMA);//
    }, 1000);
    // console.log(this.clockInterval, this.currentTime)

  }

  private refresh() {
    this.dayBoardDateService.dateChanged$.next(this.currentDate)
  }

  private validateApplicationVersion() {
    var woAppVersion = this.staticService.getApplicationPreference(AppConstant.Preferences.APP_VERSION);
    var versionAvailable = woAppVersion && woAppVersion.preferenceValue && process.env.appVersion;
    var isVersionMismatch = !this._versionVerified && versionAvailable && !(woAppVersion.preferenceValue == process.env.appVersion);
    if (isVersionMismatch) {
      //    logger.error('Version Mismatch. Client Version: ' + env.appVersion + ', New Version: ' + woAppVersion.preferenceValue, { log: true, appendDeviceInfo: true });
      this._versionVerified = true;
      var validateVersion = this.staticService.getApplicationPreference(AppConstant.Preferences.WO_VALIDATE_APP_VERSION);
      validateVersion = validateVersion && (validateVersion.preferenceValue == 'N');

      this.openApplicationUpdateDialog();
    }
  }

  openApplicationUpdateDialog() {
    // this.dialog.open(ConfirmDialogComponent)
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Application Update Available',
        message: "<div class='component-const-message'>" + this.homeService.getVersionMismatchMessage() + "</div>",
        isCancelNo: false,
        orderView: false,
        viewAlert: true,
        showNo: false,
        YES: 'No Thanks, I will do it later',
        updateDialog: true
      },
      disableClose: true,

    });

    dialogRef.afterClosed().subscribe((result) => {

    })
  }

  /*********************Private Methods*********************/


  /*********************Component Methods*********************/
  onLogoutClick(logoutMethod:string = 'timeout') {
    this.logOut(logoutMethod);
  }
  onShowUserInfoClick() {
    this.showUserInfo = !this.showUserInfo
  }

  changeDefaultAccount(defaultChecked: any) {
    let defaultShipToNumber: any = null;
    let userDetail: any = {
      userDetailNum: this.user.userDetailNum,
      customerShipToNum: this.selectedAccount.customerShipToNum,
      eventType: defaultChecked ? AppEvents.DEFAULT_ACCOUNT_REMOVED : AppEvents.DEFAULT_ACCOUNT_SELECTED,
    }
    this.accountService
      .updateDefaultAccount(userDetail)
      .subscribe((response) => {
        if (response) {
          this.selectedAccount.isDefault = !defaultChecked
          switch (userDetail.eventType) {

            case 'DEFAULT_ACCOUNT_SELECTED':

              defaultShipToNumber = this.selectedAccount.customerShipToNum;

              break;



            case 'DEFAULT_ACCOUNT_REMOVED':

              defaultShipToNumber = null;

              break;

          }
          let loggedInUserDetails = this.cache.get(CacheConstant.LocalStorage.UserDetails);

          if (loggedInUserDetails) {
            loggedInUserDetails.showLoginShipToNumber = this.selectedAccount.customerShipToNum;

            loggedInUserDetails.defaultShipToNumber = defaultShipToNumber;

            this.cache.set(CacheConstant.LocalStorage.UserDetails, loggedInUserDetails)
          }



        }
      })
  }

  loadUserDetails(principal: any, changedShipTo = null) {
    //  this.alertService.resetReservations();
    if (principal) {
      this.user = principal;
      this.accountList = this.user.customerAccountsList
      this.accountList.sort((a: any, b: any) => a.customerName.localeCompare(b.customerName));
      let loggedInShipToNum = -1;
      if (!changedShipTo) {
        loggedInShipToNum = principal.showLoginShipToNumber
      } else {
        loggedInShipToNum = changedShipTo;
      }


      this.accountList.forEach((customerAccount: any) => {
        let customerAccTimezone = this.utilityService.setCustomerAccTimeZone(customerAccount, this.cache.get(CacheConstant.LocalStorage.StaticData).timezones);
        if (customerAccount.customerShipToNum == loggedInShipToNum) {
          this.cache.set(CacheConstant.SessionStorageData.TimeZoneText, customerAccTimezone.timeZoneDesc);
          this.selectedAccount = customerAccount;
          this.cache.set('selectedAccount',this.selectedAccount);
          customerAccount.isDefault = principal?.defaultShipToNumber && principal?.defaultShipToNumber == customerAccount.customerShipToNum ? true : false;
          customerAccount.timeZoneText = customerAccTimezone.timeZoneCode;
          moment.tz.setDefault(customerAccTimezone.timeZoneDesc);
          this.setDateTime();
          this.dayBoardDateService.dateChanged$.next(this.currentDate);
        }
      })
    }
    // this.getMobileConfigurations();

  }

  showSuggestionPopOver = false;
  showPopover() {
    this.showSuggestionPopOver = !this.showSuggestionPopOver;
  }

  onSendSuggestionClick() {
    var req = {
      accountNumber: this.selectedAccount.customerShipToNum,
      suggestion: this.suggestionBox,
      userDetailNum: this.user.userDetailNum
    }
    this.commonService.sendSuggestion(req).subscribe((res: IResponse) => {
      this.toastService.success("Suggestion Sent Successfully")
    })
    this.showSuggestionPopOver = false;
  }

  onSuggestionBox($event: any) {
    this.suggestionBox = $event.target.value;
  }

  onCancelSuggestionClick() {
    this.showSuggestionPopOver = false;

  }


  changeAccount(accountSelected: any) {
    this.selectedAccount = accountSelected;

    let userDetail = {
      userDetailNum: this.user.userDetailNum,
      customerShipToNum: this.selectedAccount.customerShipToNum,
      eventType: AppEvents.ACCOUNT_CHANGED
    };
    this.accountService
      .updateDefaultAccount(userDetail)
      .subscribe((response: any) => {

        this.accountService
          .generateOktaToken()
          .subscribe((res: any) => {
            if (!this.selectedAccount.syntracShipTo) {
              this.storage.store(
                CacheConstant.SessionStorageData.ShipTo,
                this.selectedAccount.customerShipToNum
              );
              this.principal.identity(this.selectedAccount.customerShipToNum).then((response) => {
                this.loggedInUser = this.cache.get(CacheConstant.LocalStorage.UserDetails);
                this.loadUserDetails(this.loggedInUser, this.selectedAccount.customerShipToNum);
                this.storage.store(CacheConstant.SessionStorageData.AuthToken,  res.headers.get('Access-Token'));
                this._router.navigateByUrl('dashboard');
                this.getMobileConfigurations();
                this.getPharmacyHolidayDates();
              });

            }
            else
            {
              window.location.href = this.accountService.getSyntracUrl(res.headers.get('Access-Token'));

            }
          });
      });
  }

  // showEODReport() {
  //   this.dialog
  //     .open(EodReportComponent, {
  //       data: {
  //         dayBoardDate: this.currentDate,
  //       },
  //     })
  //     .afterClosed()
  //     .subscribe((data) => {
  //     })
  // }

  onDateChanged() {
  }

  changeSecurityQuestion() {
    let _securityQuestionUrl = this.commonService.changeSecurityQuestion(this.user.emailId + "/");
    window.open(_securityQuestionUrl);
  }

  logOut(logoutMethod:string = 'timeout') {
    if (this.homeService.getOrderCountByStatus(OrderStatusCodes.Unsent) > 0 && (this.userRoleDetails.roleAssigned == this.noRoleAssignStatus.RolesAssigned)) {
      this.showUnsentOrderNotSentWarning();
    }
    else {
      this.authService.logOut(logoutMethod);
    }
  }

  showUnsentOrderNotSentWarning() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: AppConstant.Messages.Schedule.UnsentOrderTitle,
        message: "<div class='component-const-message'>There are unsent orders for date <b>'" + moment(this.currentDate).format(DateFormat.MMDDYYYY) +
          //  this.currentDate | date: 'MM/dd/yyyy'}}
          "'</b>. Do you want to send the orders ?</div>",
        failedOrders: [],
        isCancelNo: false,
        orderView: false,
        deleteComponent: true,
        showNo: true,
        YES: 'YES',
        NO: "NO",
        updateDialog: false
      },
    });

    dialogRef.afterClosed().subscribe((result) => {      
        if (result ===  true  || result?.data) {
          this.sendOrders();
        }
        else {
          const logoutMethod = 'user';
          this.authService.logOut(logoutMethod);
      }
    });
  }


  sendOrders() {
    let mobileDetails = this.cache.get(CacheConstant.SessionStorageData.MobileDetails);
    let sendOrderParams: any = {};
    sendOrderParams.customerShipToNum = this.selectedAccount.customerShipToNum,
      sendOrderParams.locationNum = this.selectedAccount.locationNum,
      sendOrderParams.startDate = moment(this.homeService._dashboardDate).startOf("day").utc().format();
    sendOrderParams.userRole = this.loggedInUser.userRoleXrefList.find((x: any) => x.appTypeCode === 1).roleNum;
    sendOrderParams.mobileNum = mobileDetails ? mobileDetails.mobileNum : -1;    
    this.homeService.sendOrders(sendOrderParams).subscribe((response: any) => {      
      if (!response.hasError) {
        this.toastService.success("Orders have been sent to pharmacy.");

        // this.getDashboardDetails();
      }
      else if (response.error.status == 412) {
        if (response.error.notificationType == 'MODAL') {
          this.getSendOrderErrorObj(response.error);
        }
        // const dialogRef = this.dialog.open(SendOrdersDialogComponent, {
        //   data: {
        //     width: '45%',
        //     panelClass: 'add-order-dialog',
        //     response: response.error
        //   }
        // });
        // if (response.error.error.messageDisplay == 'MODAL') {
        //   this.getSendOrderErrorObj(response.error.error);
        // }
      }
      setTimeout(() => {
        const date = this.cache.get('CurrentDate');
        this.dayBoardDateService.dateChanged$.next(date);
      }, 100);

    })
  }

  getSendOrderErrorObj(response: any) {
    this.dialog.open(ShowSpecialProductComponent, {
      width: '600px',
      panelClass: 'show-special-product',
      data: { details: response },
    })

  }

  changeDate(value: any) {
    this.changedDate = new Date(this.currentDate).setDate(
      new Date(this.currentDate).getDate() + value,
    )
    this.dayBoardDate = moment(this.changedDate).format(DateFormat.DMDY)
    this.currentDate = new Date(this.changedDate)
    this.showToday = this.checkDate()
    this.dayBoardDateService.dateChanged$.next(this.changedDate);
  }

  dateChange(date: any) {
    let timeOffset= (moment(date).utcOffset() + new Date(date).getTimezoneOffset()) * 60 * 1000;
    this.currentDate = moment(new Date(date.getTime() - timeOffset)).format();
    this.dayBoardDate = moment(new Date(date.getTime() - timeOffset)).format(DateFormat.DMDY);
    this.showToday = this.checkDate()
    this.dayBoardDateService.dateChanged$.next(this.currentDate);
  }

  checkDate() {
    return moment(this.currentDate).format(DateFormat.MMDDYYYY) == moment().format(DateFormat.MMDDYYYY)
      ? false
      : true
  }

  openMobileDialog(): void {
    const dialogRef = this.dialog.open(SelectMobileDialogComponent, {
      width: '40%',
      panelClass: 'slect-mobile-dialog-class',
      data: { account: this.selectedAccount.customerName, mobiles: this.mobileList },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((mobile) => {
      this.selectedMobile = mobile;
      this.cache.set(CacheConstant.SessionStorageData.MobileDetails, this.selectedMobile);
      this.isRejectDialogReq();
      if (this.alertService.isReservationsLoaded() && this.reservationCount > 0) {
        this.openReservationsDialog();
      }
    });
  }

  searchAccountByShipTo(term: string, item: any) {
    var text = term.toUpperCase()
    return (
      item.customerShipToNum.toString().toUpperCase().indexOf(text) > -1 ||
      item.customerName.toUpperCase().indexOf(text) > -1
    )
  }

  openRequest() {
    this.dialog
      .open(RejectedRequestComponent, {

      })
      .afterClosed().subscribe((result) => {
        if (result.data) {
          // this.getData(date)
        }

      });
  }

  isRejectDialogReq(){
    if(this.showNewRejectNotification && this.rejectedCount > 0){
      this.openRejectNotificationDialog();
    }
  }

  openRejectNotificationDialog() {
    this.dialog
      .open(RejectNotificationComponent, {
      disableClose:true
      })
      .afterClosed().subscribe((result) => {
        if (result?.data) {
          // this.getData(date)
        }

      });
  }

  openReservationsDialog() {
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '600px',
      panelClass: 'slect-mobile-dialog-class',
      data: {
        title: 'Reservation Alerts',
        message: '<div class="component-const-message">You have Reservation(s) that have not been scheduled.</div>',
        isCancelNo: true,
        orderView: false,
        viewAlert: true,
        updateDialog: false
      },
      disableClose: true,

    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        this._router.navigate(['/alerts/reservation'])
      }
    })
  }

  showTodayData() {
    this.setDateTime();
    this.showToday = false;
    this.refresh();
  }

  getPharmacyHolidayDates() {
    let locationNumber= this.selectedAccount.locationNum;
    let currentDate = moment(this.currentDate).format('YYYY-MM-DD');
    let nextYearDate = moment(this.currentDate).add(1,'year').format('YYYY-MM-DD');
    this.homeService.getLocationHolidayDates(locationNumber,currentDate,nextYearDate).subscribe((pharmacyHolidayDates:pharmacyHolidayResponse[]) => {
      this.getLocationHolidayDates = pharmacyHolidayDates;
      this.cache.set(CacheConstant.LocalStorage.PhamacyHolidayList,this.getLocationHolidayDates);
    })
  }

  /*********************Component Methods*********************/
}
